import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import Link from "next/link";

export function OtherResult({ keyword, onClick }: { keyword?: string; onClick: () => void }) {
  if (!keyword) {
    <></>;
  }

  return (
    <div>
      <Link
        href={`/lowongan-dalam-negeri/lowongan?keyword=${keyword}`}
        className="flex p-3 items-start gap-2 hover:bg-gray-200 rounded-lg"
        onClick={onClick}
      >
        <MagnifyingGlassIcon className="size-5 min-w-5 mt-1" />
        <div className="flex-1">
          Cari lowongan kerja <span className="font-semibold">{keyword}</span>
        </div>
      </Link>
      <Link href={`/perusahaan?keyword=${keyword}`} className="flex p-3 items-start gap-2 hover:bg-gray-200 rounded-lg" onClick={onClick}>
        <MagnifyingGlassIcon className="size-5 min-w-5 mt-1" />
        <div className="flex-1">
          Cari perusahaan <span className="font-semibold">{keyword}</span>
        </div>
      </Link>
      <Link
        href={`/instansi-pemerintah?keyword=${keyword}`}
        className="flex p-3 items-start gap-2 hover:bg-gray-200 rounded-lg"
        onClick={onClick}
      >
        <MagnifyingGlassIcon className="size-5 min-w-5 mt-1" />
        <div className="flex-1">
          Cari instansi pemerintah <span className="font-semibold">{keyword}</span>
        </div>
      </Link>
    </div>
  );
}
